import actions from '../actions/companys';
import base from '../../../reducers/base';

const reducer = base(actions.types);
export default reducer;